import React, { useState, useEffect } from 'react';
import Autosuggest from 'react-autosuggest';
import courtMappings from "../../json/court_mappings.json"

const API_URL = process.env.REACT_APP_API_URL;
const token = localStorage.getItem('accessToken');

// Helper to map county/case to court info
function getCourtInfo(rec) {
  const countyKey = rec.county
    ? rec.county.charAt(0).toUpperCase() + rec.county.slice(1)
    : '';
  const mapping = courtMappings[countyKey];
  if (!mapping) {
    return {
      court_name: '',
      court_street: '',
      court_city: '',
      court_state: '',
      court_zip: '',
    };
  }
  if (Array.isArray(mapping)) {
    const prefix = rec.case_number || '';
    const found = mapping.find(e => prefix.startsWith(e.case_prefix));
    const entry = found || mapping[0];
    return {
      court_name: entry.court_name,
      court_street: entry.court_street,
      court_city: entry.court_city,
      court_state: entry.court_state,
      court_zip: entry.court_zip,
    };
  }
  return {
    court_name: mapping.court_name,
    court_street: mapping.court_street,
    court_city: mapping.court_city,
    court_state: mapping.court_state,
    court_zip: mapping.court_zip,
  };
}
export default function LawsuitSection({ caseId, sofaResponse, caseData, priorAddresses }) {
  const [lawsuits, setLawsuits] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  console.log(caseData)
  console.log(priorAddresses)
  const [newLawsuit, setNewLawsuit] = useState({
    case_title: '',
    case_number: '',
    nature_of_case: '',
    court_name: '',
    court_street: '',
    court_city: '',
    court_state: '',
    court_zip: '',
    status: 'pending',
  });
  const [editLawsuitData, setEditLawsuitData] = useState(null);
  const [commonCreditorQuery, setCommonCreditorQuery] = useState('');
  const [commonCreditorSuggestions, setCommonCreditorSuggestions] = useState([]);
  const [commonCreditorLoading, setCommonCreditorLoading] = useState(false);
  const [commonCreditorError, setCommonCreditorError] = useState('');
  // --- Search modal state ---
// --- Search modal state ---
const [searchModalOpen, setSearchModalOpen] = useState(false);
const [searchResults, setSearchResults] = useState([]);
const [searchLoading, setSearchLoading] = useState(false);
const [searchTargets, setSearchTargets] = useState([]); // [{type:'name'|'address', label, status, _payload, _idx}]
const [searchProgress, setSearchProgress] = useState({ done: 0, total: 0 });
const [searchError, setSearchError] = useState(null);
const [currentSearchLabel, setCurrentSearchLabel] = useState('');
  // Accordion state for search results
  const [expandedIds, setExpandedIds] = useState([]);
  // Bulk select state for search results
  const [selectedRecords, setSelectedRecords] = useState([]);
  function toggleExpand(id) {
    setExpandedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  }

  useEffect(() => {
    if (!sofaResponse) return;
    async function fetchLawsuits() {
      try {
        const res = await fetch(
          `${API_URL}/cases/${caseId}/sofa-lawsuits/?sofa_response=${sofaResponse.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!res.ok) throw new Error('Failed to fetch lawsuits');
        setLawsuits(await res.json());
      } catch (err) {
        console.error(err);
      }
    }
    fetchLawsuits();
  }, [sofaResponse, caseId]);

  function openAddModal() {
    setNewLawsuit({
      case_title: '',
      case_number: '',
      nature_of_case: '',
      court_name: '',
      court_street: '',
      court_city: '',
      court_state: '',
      court_zip: '',
      status: 'pending',
    });
    setCommonCreditorQuery('');
    setCommonCreditorSuggestions([]);
    setCommonCreditorError('');
    setModalOpen(true);
  }

  async function fetchCommonCreditorSuggestions(value) {
    const query = (value || '').trim();
    if (query.length < 2) {
      setCommonCreditorSuggestions([]);
      setCommonCreditorError('');
      return;
    }

    setCommonCreditorLoading(true);
    setCommonCreditorError('');
    try {
      const res = await fetch(`${API_URL}/common-creditors/?q=${encodeURIComponent(query)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Failed to load common creditors');
      const data = await res.json();
      setCommonCreditorSuggestions(Array.isArray(data) ? data : (data.results || []));
    } catch (err) {
      console.error(err);
      setCommonCreditorSuggestions([]);
      setCommonCreditorError(err?.message || 'Failed to load common creditors');
    } finally {
      setCommonCreditorLoading(false);
    }
  }

  function selectCommonCreditor(_event, { suggestion }) {
    const courtName = suggestion.account_name || suggestion.name || '';
    setNewLawsuit(prev => ({
      ...prev,
      court_name: courtName || prev.court_name,
      court_street: suggestion.street1 || suggestion.street || suggestion.address || prev.court_street,
      court_city: suggestion.city || prev.court_city,
      court_state: suggestion.state || prev.court_state,
      court_zip: suggestion.zip_code || suggestion.zip || prev.court_zip,
    }));
    setCommonCreditorQuery(courtName);
    setCommonCreditorSuggestions([]);
    setCommonCreditorError('');
  }

  const commonCreditorTheme = {
    container: 'relative w-full',
    containerOpen: 'relative w-full',
    input: 'w-full border rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500',
    inputOpen: 'w-full border rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500',
    inputFocused: 'w-full border border-indigo-500 rounded px-2 py-1 bg-white outline-none ring-2 ring-indigo-500',
    suggestionsContainer: 'absolute z-20 mt-1 w-full',
    suggestionsContainerOpen: 'absolute z-20 mt-1 w-full max-h-64 overflow-y-auto rounded border bg-white shadow-lg',
    suggestionsList: 'divide-y divide-gray-100',
    suggestion: 'cursor-pointer px-3 py-2 text-sm',
    suggestionHighlighted: 'cursor-pointer bg-indigo-50 px-3 py-2 text-sm',
  };
// Build unique targets (names & addresses) from props
function extractTargetsFromProps() {
  const names = [];
  const addrs = [];

  // filing debtors (names + current addresses)
  const debtors = Array.isArray(caseData?.debtors) ? caseData.debtors : [];
  debtors.forEach(d => {
    if (!d || d.is_filing === false) return;
    const first = (d.first_name || '').trim();
    const last = (d.last_name || '').trim();
    if (first && last) names.push({ first_name: first, last_name: last });

    // include alias names for filing debtors
    const aliases = Array.isArray(d.aliases) ? d.aliases : [];
    aliases.forEach(al => {
      let af = '';
      let alast = '';
      if (al && typeof al === 'object') {
        af = (al.first_name || al.first || '').trim();
        alast = (al.last_name || al.last || '').trim();
        if ((!af || !alast)) {
          const nm = (al.full_name || al.name || '').trim();
          if (nm) {
            const parts = nm.split(/\s+/).filter(Boolean);
            if (parts.length >= 2) {
              af = parts[0];
              alast = parts[parts.length - 1];
            }
          }
        }
      } else if (typeof al === 'string') {
        const parts = al.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
          af = parts[0];
          alast = parts[parts.length - 1];
        }
      }
      if (af && alast) {
        names.push({ first_name: af, last_name: alast });
      }
    });

    const street = (d.street || d.street1 || '').trim();
    const zip = (d.zip_code || d.zip || '').toString().trim();
    if (street && zip) addrs.push({ street1: street, zip_code: zip });
  });

  // prior addresses passed in
  const priors = Array.isArray(priorAddresses) ? priorAddresses : [];
  priors.forEach(a => {
    if (!a) return;
    const street1 = (a.street1 || a.street || '').trim();
    const zip = (a.zip_code || a.zip || '').toString().trim();
    if (street1 && zip) addrs.push({ street1, zip_code: zip });
  });

  // de-dupe (case-insensitive)
  const seenN = new Set();
  const uniqNames = [];
  for (const n of names) {
    const k = `${n.first_name}||${n.last_name}`.toLowerCase();
    if (!seenN.has(k)) { seenN.add(k); uniqNames.push(n); }
  }
  const seenA = new Set();
  const uniqAddrs = [];
  for (const a of addrs) {
    const k = `${a.street1}||${a.zip_code}`.toLowerCase();
    if (!seenA.has(k)) { seenA.add(k); uniqAddrs.push(a); }
  }

  return { names: uniqNames, addresses: uniqAddrs };
}
  function openEditModal(item) {
    setEditLawsuitData(item);
    setEditModalOpen(true);
  }

  async function handleSaveNew() {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-lawsuits/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ ...newLawsuit })
        }
      );
      if (!res.ok) throw new Error('Failed to add lawsuit');
      const created = await res.json();
      setLawsuits(prev => [...prev, created]);
      setModalOpen(false);
    } catch (err) {
      console.error(err);
    }
  }

  async function handleSaveEdit() {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-lawsuits/${editLawsuitData.id}/`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ ...editLawsuitData })
        }
      );
      if (!res.ok) throw new Error('Failed to update lawsuit');
      const updated = await res.json();
      setLawsuits(prev => prev.map(l => l.id === updated.id ? updated : l));
      setEditModalOpen(false);
    } catch (err) {
      console.error(err);
    }
  }

  async function handleDelete(id) {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-lawsuits/${id}/`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (!res.ok) throw new Error('Failed to delete lawsuit');
      setLawsuits(prev => prev.filter(l => l.id !== id));
    } catch (err) {
      console.error(err);
    }
  }

  // --- Search Court Records modal handlers ---
// --- Search Court Records modal handlers ---
async function openSearchModal() {
  setSelectedRecords([]);
  setSearchResults([]);
  setSearchTargets([]);
  setSearchProgress({ done: 0, total: 0 });
  setSearchError(null);
  setSearchLoading(true);
  setSearchModalOpen(true);
  setCurrentSearchLabel('');

  // simple dedupe by case_number/id
  const dedupe = (arr) => {
    const map = new Map();
    for (const r of arr) {
      if (!r) continue;
      const k = r.case_number || r.unique_id || r.id || JSON.stringify(r);
      if (!map.has(k)) map.set(k, r);
    }
    return Array.from(map.values());
  };

  try {
    const { names, addresses } = extractTargetsFromProps();
    const targetRows = [
      ...names.map(n => ({ type: 'name', label: `${n.first_name} ${n.last_name}`.trim(), status: 'queued', _payload: n })),
      ...addresses.map(a => ({ type: 'address', label: `${a.street1}, ${a.zip_code}`.trim(), status: 'queued', _payload: a })),
    ];
    setSearchTargets(targetRows.map((t, idx) => ({ ...t, _idx: idx })));
    setSearchProgress({ done: 0, total: targetRows.length });

    if (targetRows.length === 0) {
      setSearchError('No filing debtor names or addresses to search.');
      return;
    }

    // build tasks – one backend POST per target
    const tasks = targetRows.map((t, idx) => async () => {
      setSearchTargets(prev => prev.map(r => r._idx === idx ? { ...r, status: 'running' } : r));
      setCurrentSearchLabel(t.label || (t.type === 'name' ? `${t._payload.first_name} ${t._payload.last_name}` : `${t._payload.street1}, ${t._payload.zip_code}`));
      try {
        let res;
        if (t.type === 'name') {
          res = await fetch(`${API_URL}/cases/${caseId}/sofa-lawsuits/search/name/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ first_name: t._payload.first_name, last_name: t._payload.last_name })
          });
        } else {
          res = await fetch(`${API_URL}/cases/${caseId}/sofa-lawsuits/search/address/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ street1: t._payload.street1, zip_code: t._payload.zip_code })
          });
        }
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const chunk = await res.json();
        if (Array.isArray(chunk) && chunk.length) {
          setSearchResults(prev => dedupe([...prev, ...chunk]));
        }
        setSearchTargets(prev => prev.map(r => r._idx === idx ? { ...r, status: 'done' } : r));
      } catch (e) {
        setSearchTargets(prev => prev.map(r => r._idx === idx ? { ...r, status: 'error' } : r));
      } finally {
        setSearchProgress(prev => ({ ...prev, done: prev.done + 1 }));
      }
    });

    // run sequentially (limit = 1)
    for (let i = 0; i < tasks.length; i++) {
      // eslint-disable-next-line no-await-in-loop
      await tasks[i]();
    }
  } catch (err) {
    console.error('Search error', err);
    setSearchError(err?.message || 'Search failed.');
  } finally {
    setSearchLoading(false);
  }
}

  function handleSelectRecord(rec) {
    const courtInfo = getCourtInfo(rec);
    setNewLawsuit({
      case_title: rec.case_title || rec.defendant || '',
      case_number: rec.case_number || '',
      nature_of_case: rec.case_type || rec.nature || '',
      court_name: courtInfo.court_name,
      court_street: courtInfo.court_street,
      court_city: courtInfo.court_city,
      court_state: courtInfo.court_state,
      court_zip: courtInfo.court_zip,
      status: ['closed','disposed'].includes(rec.case_status?.toLowerCase()) ? 'concluded' : 'pending',
    });
    setSearchModalOpen(false);
    setModalOpen(true);
  }

  // Bulk add selected search results
  async function handleAddSelected() {
    setAddLoading(true);
    const createdItems = [];
    for (const key of selectedRecords) {
      const rec = searchResults.find(r =>
        (r.case_number || r.unique_id || '').toString() === key.toString()
      );
      if (!rec) continue;
      const courtInfo = getCourtInfo(rec);
      const payload = {
        case_title: rec.case_title || rec.defendant || '',
        case_number: rec.case_number || '',
        nature_of_case: rec.case_type || rec.nature || '',
        court_name: courtInfo.court_name,
        court_street: courtInfo.court_street,
        court_city: courtInfo.court_city,
        court_state: courtInfo.court_state,
        court_zip: courtInfo.court_zip,
        status: ['closed','disposed'].includes(rec.case_status?.toLowerCase()) ? 'concluded' : 'pending',
      };
      try {
        const res = await fetch(
          `${API_URL}/cases/${caseId}/sofa-lawsuits/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
          }
        );
        if (res.ok) {
          createdItems.push(await res.json());
        }
      } catch (err) {
        console.error('Failed to add record', err);
      }
    }
    if (createdItems.length) {
      setLawsuits(prev => [...prev, ...createdItems]);
    }
    // reset selection and close
    setSelectedRecords([]);
    setAddLoading(false);
    setSearchModalOpen(false);
  }

  return (
    <section className="p-6 bg-white shadow-lg rounded mb-6">
      <h2 className="text-xl font-semibold mb-4">Question 9: Lawsuit Filings</h2>
      <p className="text-sm text-gray-600 mb-4">
    List lawsuit court actions or administrative proceedings you have been party to in the last year. Include personal injury cases, small claims, divorce, collection, paternity support and custody modifications.
  </p>
      {lawsuits.length === 0 ? (
        <p>No lawsuits found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
          {lawsuits.map(item => (
            <div
              key={item.id}
              className="p-4 bg-white shadow rounded cursor-pointer relative hover:shadow-lg transition-shadow"
              onClick={() => openEditModal(item)}
            >
              <button
                onClick={e => { e.stopPropagation(); handleDelete(item.id); }}
                className="absolute top-2 right-2 text-red-600 hover:text-red-800"
              >
                {/* Trash Icon */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                    2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                    6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                    2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2
                    0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                    00-2 0z"/>
                </svg>
              </button>
              <h3 className="font-medium text-lg">{item.case_title}</h3>
              <p className="mt-2 text-sm"><strong>Case #:</strong> {item.case_number || '—'}</p>
              <p className="mt-2 text-sm"><strong>Nature:</strong> {item.nature_of_case}</p>
              <p className="mt-2 text-sm"><strong>Court:</strong> {item.court_name}, {item.court_city}, {item.court_state}</p>
              <p className="mt-2 text-sm"><strong>Status:</strong> {item.status}</p>
            </div>
          ))}
        </div>
      )}
      <button
        onClick={openAddModal}
        className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
      >
        Add Lawsuit Filing
      </button>
      <button
        onClick={openSearchModal}
        className="ml-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Search Court Records
      </button>

      {/* Search Court Records Modal */}
      {searchModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`bg-white p-4 sm:p-6 rounded-lg shadow-lg ring-1 ring-gray-200 w-11/12 ${
              searchResults.length > 0
                ? 'max-w-4xl max-h-[90vh] overflow-y-auto'
                : 'max-w-xl'
            }`}
          >
            <h3 className="text-lg font-semibold mb-4">Searching Court Records</h3>
            <div className="flex justify-end mb-4">
              <button
                onClick={() => setSearchModalOpen(false)}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
              >
                Close
              </button>
            </div>
            {/* Status + progress */}
            <div className="mb-3">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                  {searchProgress.total > 0
                    ? `Searching ${searchProgress.done} / ${searchProgress.total} targets…`
                    : (searchLoading ? 'Preparing targets…' : 'Ready')}
                </div>
                <div className="text-sm text-gray-700">Results: {searchResults.length}</div>
              </div>
              <div className="mt-2 h-2 bg-gray-200 rounded overflow-hidden">
                <div
                  className="h-full bg-blue-600 transition-all"
                  style={{ width: `${searchProgress.total ? Math.round((searchProgress.done / searchProgress.total) * 100) : 0}%` }}
                />
              </div>
              {currentSearchLabel && (
                <div className="mt-2 text-xs text-gray-600">
                  Currently searching: <span className="font-medium">{currentSearchLabel}</span>
                </div>
              )}
            </div>

            {/* Visible queue of what’s being searched */}
            {Array.isArray(searchTargets) && searchTargets.length > 0 && (
              <div className="mb-4 border rounded">
                <div className="px-3 py-2 bg-gray-100 text-sm font-medium">Search Queue</div>
                <ul className="max-h-44 overflow-y-auto divide-y">
                  {searchTargets.map((t, idx) => (
                    <li key={t._idx ?? idx} className="px-3 py-2 text-sm flex items-center gap-2">
                      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs border ${t.type === 'name' ? 'bg-purple-50 border-purple-200 text-purple-700' : 'bg-amber-50 border-amber-200 text-amber-700'}`}>
                        {t.type || 'target'}
                      </span>
                      <span className="truncate">{t.label || (t.type === 'name' ? `${t._payload?.first_name} ${t._payload?.last_name}` : `${t._payload?.street1}, ${t._payload?.zip_code}`)}</span>
                      <span className="ml-auto">
                        {t.status === 'running' && (
                          <svg className="animate-spin h-4 w-4 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                          </svg>
                        )}
                        {t.status === 'queued' && <span className="text-gray-400">queued</span>}
                        {t.status === 'done' && <span className="text-green-600">done</span>}
                        {t.status === 'error' && <span className="text-red-600">error</span>}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Loading spinner if still working and no results yet */}
            {searchLoading && searchResults.length === 0 && (
              <div className="flex justify-center items-center py-6">
                <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
              </div>
            )}

            {/* Results list */}
            {searchResults.length > 0 && (
              <div className="mt-4 max-h-800 overflow-y-auto">
                {/* Inline spinner for bulk-add loading */}
                {addLoading && (
                  <div className="flex justify-center items-center py-4">
                    <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                    </svg>
                  </div>
                )}
                {searchResults.map((rec, idx) => {
                  const key = rec.case_number || rec.unique_id || idx;
                  const isOpen = expandedIds.includes(key);
                  return (
                    <div key={key} className="border-b">
                      <div className="flex items-center p-2">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={selectedRecords.includes(key)}
                          onChange={e => {
                            if (e.target.checked) {
                              setSelectedRecords(prev => [...prev, key]);
                            } else {
                              setSelectedRecords(prev => prev.filter(x => x !== key));
                            }
                          }}
                        />
                        <span className="font-medium">{rec.case_title || rec.defendant} - {rec.county} - {rec.case_number}</span>
                        <button
                          onClick={() => toggleExpand(key)}
                          className="ml-auto flex items-center"
                        >
                          <svg
                            className={`h-5 w-5 transition-transform ${isOpen ? 'transform rotate-180' : ''}`}
                            fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                      </div>
                      {isOpen && (
                        <div className="p-2 bg-gray-50">
                          <p><strong>Case Number:</strong> {rec.case_number}</p>
                          <p><strong>Plaintiff:</strong> {rec.plaintiff}</p>
                          <p><strong>Status:</strong> {rec.case_status}</p>
                          <p><strong>County:</strong> {rec.county}</p>
                          <p><strong>File Date:</strong> {rec.file_date}</p>
                          <p><strong>Hearing Date:</strong> {rec.hearing_date || '—'}</p>
                          <p><strong>Judge:</strong> {rec.judge}</p>
                          <h4 className="mt-2 font-semibold">Parties & Addresses:</h4>
                          {rec.case_of_party?.map((party, i) => (
                            <div key={i} className="mb-2">
                              <p><strong>Defendant:</strong> {party.defendant}</p>
                              <p><strong>Address:</strong> {party.street}, {party.city}, {party.state} {party.zip_code}</p>
                            </div>
                          ))}
                          <h4 className="mt-2 font-semibold">Recent Dockets:</h4>
                          <ul className="list-disc ml-4">
                            {(rec.case_of_party || []).flatMap(party => (party?.dockets || [])).slice(0,5).map((d, j) => (
                              <li key={j}>
                                <span className="font-medium">{new Date(d.date_time).toLocaleDateString()}</span>: {d.entry}
                              </li>
                            ))}
                          </ul>
                          <div className="mt-2">
                            <a href={rec.case_of_party?.[0]?.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                              View Full Court Record
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    disabled={selectedRecords.length === 0}
                    onClick={handleAddSelected}
                    className={`px-4 py-2 rounded text-white ${
                      selectedRecords.length === 0
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                  >
                    Add Selected ({selectedRecords.length})
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Add Lawsuit Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Add Lawsuit Filing</h3>
            <div className="mb-4 rounded border border-indigo-200 bg-indigo-50 p-3">
              <label className="block text-sm font-medium mb-1">Quick Fill Court from Common Creditors</label>
              <Autosuggest
                suggestions={commonCreditorSuggestions}
                onSuggestionsFetchRequested={({ value }) => fetchCommonCreditorSuggestions(value)}
                onSuggestionsClearRequested={() => setCommonCreditorSuggestions([])}
                getSuggestionValue={(suggestion) => suggestion.account_name || suggestion.name || ''}
                renderSuggestion={(suggestion) => (
                  <div>
                    <div className="font-medium">{suggestion.account_name || suggestion.name}</div>
                    <div className="text-xs text-gray-500">
                      {[suggestion.street1 || suggestion.street || suggestion.address, suggestion.street2]
                        .filter(Boolean)
                        .join(', ')}
                    </div>
                    <div className="text-xs text-gray-400">
                      {[suggestion.city, suggestion.state, suggestion.zip_code || suggestion.zip]
                        .filter(Boolean)
                        .join(' ')}
                    </div>
                  </div>
                )}
                onSuggestionSelected={selectCommonCreditor}
                inputProps={{
                  placeholder: 'Start typing a court or common creditor name…',
                  value: commonCreditorQuery,
                  onChange: (_event, { newValue }) => setCommonCreditorQuery(newValue),
                }}
                highlightFirstSuggestion
                theme={commonCreditorTheme}
              />
              {commonCreditorLoading && <p className="mt-1 text-xs text-gray-500">Loading suggestions…</p>}
              {commonCreditorError && <p className="mt-1 text-xs text-red-600">{commonCreditorError}</p>}
              <p className="mt-1 text-xs text-gray-600">
                Selecting a result fills the court name and address. The case title, number, and nature remain available for you to enter separately.
              </p>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Case Title</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newLawsuit.case_title}
                onChange={e => setNewLawsuit(prev => ({ ...prev, case_title: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Case Number</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newLawsuit.case_number}
                  onChange={e => setNewLawsuit(prev => ({ ...prev, case_number: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Nature of Case</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newLawsuit.nature_of_case}
                  onChange={e => setNewLawsuit(prev => ({ ...prev, nature_of_case: e.target.value }))}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Court Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newLawsuit.court_name}
                onChange={e => setNewLawsuit(prev => ({ ...prev, court_name: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Court Street</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newLawsuit.court_street}
                onChange={e => setNewLawsuit(prev => ({ ...prev, court_street: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-7 gap-4 mb-3">
              <div className="col-span-4">
                <label className="block text-sm font-medium mb-1">Court City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newLawsuit.court_city}
                  onChange={e => setNewLawsuit(prev => ({ ...prev, court_city: e.target.value }))}
                />
              </div>
              <div className="col-span-1">
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newLawsuit.court_state}
                  onChange={e => setNewLawsuit(prev => ({ ...prev, court_state: e.target.value }))}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium mb-1">Court Zip</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newLawsuit.court_zip}
                  onChange={e => setNewLawsuit(prev => ({ ...prev, court_zip: e.target.value }))}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Status</label>
              <select
                className="w-full border rounded px-2 py-1"
                value={newLawsuit.status}
                onChange={e => setNewLawsuit(prev => ({ ...prev, status: e.target.value }))}
              >
                <option value="pending">Pending</option>
                <option value="appealed">Appealed</option>
                <option value="concluded">Concluded</option>
              </select>
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button onClick={() => setModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
              <button onClick={handleSaveNew} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Lawsuit Modal */}
      {editModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-xl">
            <h3 className="text-lg font-semibold mb-4">Edit Lawsuit Filing</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Case Title</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editLawsuitData?.case_title || ''}
                onChange={e => setEditLawsuitData(prev => ({ ...prev, case_title: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Case Number</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editLawsuitData?.case_number || ''}
                  onChange={e => setEditLawsuitData(prev => ({ ...prev, case_number: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Nature of Case</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editLawsuitData?.nature_of_case || ''}
                  onChange={e => setEditLawsuitData(prev => ({ ...prev, nature_of_case: e.target.value }))}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Court Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editLawsuitData?.court_name || ''}
                onChange={e => setEditLawsuitData(prev => ({ ...prev, court_name: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Court Street</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editLawsuitData?.court_street || ''}
                onChange={e => setEditLawsuitData(prev => ({ ...prev, court_street: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-7 gap-4 mb-3">
              <div className="col-span-4">
                <label className="block text-sm font-medium mb-1">Court City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editLawsuitData?.court_city || ''}
                  onChange={e => setEditLawsuitData(prev => ({ ...prev, court_city: e.target.value }))}
                />
              </div>
              <div className="col-span-1">
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editLawsuitData?.court_state || ''}
                  onChange={e => setEditLawsuitData(prev => ({ ...prev, court_state: e.target.value }))}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium mb-1">Court Zip</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editLawsuitData?.court_zip || ''}
                  onChange={e => setEditLawsuitData(prev => ({ ...prev, court_zip: e.target.value }))}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Status</label>
              <select
                className="w-full border rounded px-2 py-1"
                value={editLawsuitData?.status || ''}
                onChange={e => setEditLawsuitData(prev => ({ ...prev, status: e.target.value }))}
              >
                <option value="pending">Pending</option>
                <option value="appealed">Appealed</option>
                <option value="concluded">Concluded</option>
              </select>
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button onClick={() => setEditModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
              <button onClick={handleSaveEdit} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
            </div>
          </div>
        </div>
      )}
    </section>
);
}
